import {Component, OnDestroy} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {Observable, Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {NGPReport} from '../../../../shared-utilities/models-old/ngp-reports/ngp-report';
import {StockItem} from '../../../../shared-utilities/models-old/datastructures';
import {selectCurrentNavigationPage} from '../../../../features/user-access/user-stores-store/user-store.selectors';
import {takeUntil} from 'rxjs/operators';
import {decodeOnHoldCode} from '../../../../shared/shared-module-ui/utils/on-hold-code/on-hold-code.utils';

@Component({
  selector: 'app-cell-renderer-multi-select',
  templateUrl: './cell-renderer-multi-select.component.html',
  styleUrls: ['./cell-renderer-multi-select.component.scss'],
  standalone: false,
})
export class CellRendererMultiSelectComponent implements ICellRendererAngularComp, OnDestroy {

  value: string | number;
  params: ICellRendererParams;
  width: string;
  type: string;
  currentPage$: Observable<string>;
  currentPage: string;
  protected readonly onHoldDecode = decodeOnHoldCode;

  private destroy$ = new Subject<boolean>();

  constructor(
    private readonly store: Store,
  ) {
  }

  agInit(params: ICellRendererParams): void {
    this.currentPage$ = this.store.select(selectCurrentNavigationPage);
    this.currentPage$.pipe(takeUntil(this.destroy$)).subscribe((page: string) => {
      this.currentPage = page;
    });
    this.value = params.value;
    this.type = params.colDef.field;
    this.params = params;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  refresh(params: ICellRendererParams): boolean {
    return false;
  }


  onUndoChangesClick(): void {
    this.params = {...this.params};
    this.params.data = structuredClone(this.params.data);
    this.value = this.params.data.originalValue[this.params.colDef.field].value;
    this.params.data[this.params.colDef.field] = this.value;
    GridUtils.updateErrorAndForceRefreshForOnHoldCode(this.params, +this.value);
    GridUtils.removeIsEditingFlagAndDispatch(this.params.data as NGPReport | StockItem, this.params.colDef.field, this.store, this.currentPage);
    GridUtils.updateIsEditedAndForceRefresh(this.params);
  }

}
